import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function RewindBackIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7.72 2.956 7.7 4.04a.5.5 0 0 0 .46.507 4.74 4.74 0 0 1 2.894 1.29 4.55 4.55 0 0 1 .668 5.825 4.66 4.66 0 0 1-1.866 1.622l.007-.384.003-.004a.1.1 0 0 1 .027-.025 4.3 4.3 0 0 0 1.675-1.715 4.2 4.2 0 0 0 .44-2.683 4.26 4.26 0 0 0-1.284-2.403 4.37 4.37 0 0 0-2.49-1.155.5.5 0 0 0-.557.488l-.018 1.05-2.481-1.778z" /></svg>
  );
}

export default RewindBackIcon;
